(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gravurequote-editor-preview"] && !Shopify.designMode) return;
  try {
    
function mountGQPreviews(){document.querySelectorAll('.gq-preview-host:not([data-mounted])').forEach(async host=>{host.dataset.mounted='true';const frame=host.querySelector('iframe');try{const response=await fetch(host.dataset.editorUrl);if(!response.ok)throw new Error('Chargement impossible');const data=await response.json();if(typeof data.html!=='string')throw new Error('Format invalide');const encoded=JSON.stringify(location.search).replace(/</g,'\\u003c');const html=data.html.replace('<head>','<head><script>window.gqPreviewSearch='+encoded+';<\/script>');frame.addEventListener('load',()=>host.classList.add('is-ready'),{once:true});frame.srcdoc=html}catch(error){host.querySelector('[role=status]').textContent='Impossible de charger l’éditeur. Actualisez la page.';delete host.dataset.mounted}})}mountGQPreviews();document.addEventListener('shopify:section:load',mountGQPreviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-printer"] && !Shopify.designMode) return;
  try {
    
  class LfPrinter extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const button = this.querySelector('.lf-printer__pause');
      button?.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.play : button.dataset.pause;
      }, { signal: this.controller.signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.classList.toggle('is-offscreen', !entries[0].isIntersecting);
        });
        this.observer.observe(this);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  }
  if (!customElements.get('lf-printer')) customElements.define('lf-printer', LfPrinter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
